import React from 'react';
import { Link } from 'react-router-dom';
import { PixelBoard } from '../components/PixelUI';
import { NVLogo } from '../components/Brand';
import MiniByte from '../components/MiniByte';
import { SystemMonitor, WalletDock, WirePreview, BytePreview, MintId, TickerStrip } from '../components/HomeSections';

const Home = () => {
  return (
    <main>
      {/* ---------------- HERO ---------------- */}
      <section className="nv-hero nv-stars">
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 26 }}>
            <div style={{ background: 'var(--nv-cream)', border: '3px solid var(--nv-ink)', padding: 10, boxShadow: '5px 5px 0 rgba(0,0,0,.4)' }}>
              <NVLogo size={56} />
            </div>
          </div>
          <span className="nv-kicker" data-testid="hero-kicker">
            Hourly GPU cores, settled in ETH — wired to Robinhood chain
          </span>
          <h1 data-testid="hero-title">
            NANO<span className="gold">VRAM</span>
          </h1>
          <p className="lede">
            A retro workbench that rents NV8 graphics cores by the hour. Dollar figures
            are computed live off the ledger's quote, your wallet docks through your own
            keys, and the wire carries the live ETH price — and when a feed goes
            quiet the desk prints “no signal” instead of pretending it saw a number.
          </p>
          <div className="nv-hero-ctas">
            <a href="#dock" className="px-btn" data-testid="cta-dock-wallet">Dock Wallet</a>
            <Link to="/rent" className="px-btn" data-testid="cta-rent">Rent a Core</Link>
            <a href="#wire" className="px-btn" data-testid="cta-wire">Open the Wire</a>
            <Link to="/agent" className="px-btn" data-testid="cta-byte">Ask Byte</Link>
          </div>
          <div className="nv-live-chip" data-testid="live-chip">
            <span className="nv-live-dot" /> $NVRM &middot; LIVE
          </div>

          <div className="nv-board-scene">
            <PixelBoard />
            <div className="nv-mini-byte">
              <MiniByte />
            </div>
          </div>
          <p style={{ color: 'var(--nv-tan)', fontSize: 12, letterSpacing: 3, textTransform: 'uppercase', marginTop: 26, opacity: 0.7 }}>
            every gauge on this desk reads itself
          </p>
        </div>
      </section>

      <TickerStrip />
      <SystemMonitor />
      <WalletDock />
      <WirePreview />
      <BytePreview />
      <MintId />
    </main>
  );
};

export default Home;
